import React from "react";
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from "recharts";
import { Paper, Typography } from "@mui/material";

// ✅ Define the props interface
interface LineChartComponentProps {
    data: { [key: string]: never }[];
    dataKey: string;
    title: string;
}

// ✅ Apply the type when destructuring props
const LineChartComponent = ({
                                data,
                                dataKey,
                                title,
                            }: LineChartComponentProps): JSX.Element => {
    return (
        <Paper
            sx={{
                padding: 2,
                borderRadius: 2,
                boxShadow: 2,
                backgroundColor: "#ffffff",
            }}
        >
            <Typography variant="subtitle1" gutterBottom>
                {title}
            </Typography>
            <ResponsiveContainer width="100%" height={250}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="bucket" />
                    <YAxis />
                    <Tooltip />
                    <Line
                        type="monotone"
                        dataKey={dataKey}
                        stroke="#1976d2"
                        strokeWidth={2}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </Paper>
    );
};

export default LineChartComponent;
